import CreateResourceInteractor from "../../core/interactor/app/crud/CreateResourceInteractor";
import Constants from "../common/Constants";
import { IIndexTypeGroup } from "../model/IndexTypeGroup";
import IndexTypeGroupMapper from "../service/IndexTypeGroupMapper";
import IndexTypeGroupParamMapper from "../service/IndexTypeGroupParamMapper";

export default class CreateIndexTypeGroupInteractor {
  private createResource: CreateResourceInteractor<IIndexTypeGroup>;

  constructor({ createResource }: any) {
    this.createResource = createResource;
  }

  async execute(model: IIndexTypeGroup) {
    return this.createResource.execute(
      Constants.indexGroupBasePath,
      IndexTypeGroupMapper,
      IndexTypeGroupParamMapper,
      model
    );
  }
}
